// @flow

import { useCallback } from 'react';
import { useEnrollment } from '../context';
import {
  buildCredentialCreationOptions,
  extractCredentialResponse,
  getWebAuthnErrorMessage,
} from '../services/webauthn';
import type { CredentialResponse } from '../services/webauthn';

export function useWebAuthnRegistration(): () => Promise<?CredentialResponse> {
  const { data, dispatch } = useEnrollment();

  return useCallback(async (): Promise<?CredentialResponse> => {
    if (!window.PublicKeyCredential) {
      dispatch({
        type: 'SET_ERROR',
        errorMessage: 'Seu navegador não suporta autenticação biométrica.',
      });
      return null;
    }

    const registrationOptions = data.registrationOptions;
    if (!registrationOptions) {
      dispatch({ type: 'SET_ERROR', errorMessage: 'Opções de registro não disponíveis.' });
      return null;
    }

    dispatch({ type: 'START_AUTHENTICATION' });

    try {
      const publicKeyOptions = buildCredentialCreationOptions(registrationOptions);
      // $FlowFixMe[incompatible-use] WebAuthn API not fully typed in Flow
      // $FlowFixMe[prop-missing] WebAuthn API not fully typed in Flow
      const credential = await navigator.credentials.create({ publicKey: publicKeyOptions });

      if (!credential) {
        throw new Error('WebAuthn registration returned no credential');
      }

      return extractCredentialResponse(credential);
    } catch (err) {
      const errorMessage = getWebAuthnErrorMessage(err);
      const isNonRetryable = err.name === 'NotSupportedError' || err.name === 'SecurityError' || err.name === 'InvalidStateError';

      if (isNonRetryable) {
        dispatch({ type: 'SET_ERROR', errorMessage });
      } else {
        dispatch({ type: 'SET_AUTH_ERROR', errorMessage });
      }
      return null;
    }
  }, [data.registrationOptions, dispatch]);
}
